import { FC } from 'react';
import { TextTabScrollable } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';

import { BannerGroup, ShopInfo, TextCategoryList } from '@domains/storehome-common';

import { DefaultComponentList } from '../../component-list/containers/DefaultComponentList';
import { SelectedMainBannerContainer } from '../../main-banner/containers/SelectedMainBannerContainer';
import { SelectedShopInformationContainer } from '../../shop-information/containers/SelectedShopInformationContainer';
import { ScrollWrap, SelectedTextTabWrapper } from '../components/Main.styled';
import { useMainService } from '../services/useMainService';

export interface StoreHomeViewProps {
  shop_info: ShopInfo;
  is_header_solid?: boolean;
  banner_group: BannerGroup | null;
  category_list: TextCategoryList[];
  is_preview?: boolean;
}

export const SelectedMainContainer: FC<React.PropsWithChildren<StoreHomeViewProps>> = ({
  shop_info,
  is_header_solid,
  banner_group,
  category_list,
  is_preview,
}) => {
  const {
    params,
    shop_id,
    applied_banner_group,
    categories,
    handleCategoryClick,
    component_list_props,
    exists_banner,
    onParamsChange,
    fetchNextPage,
  } = useMainService({ shop_info, banner_group, is_preview, category_list });
  return (
    <ScrollWrap>
      <SelectedMainBannerContainer banner_group={applied_banner_group} is_preview={is_preview} shop_id={shop_id} />
      <SelectedShopInformationContainer shop_info={shop_info} is_cover_view={exists_banner} />
      <SelectedTextTabWrapper id='storehome-navigation-bar'>
        <TextTabScrollable
          defaultValue={null}
          items={categories}
          onChange={handleCategoryClick}
          hideBorderBottom
          impressionMode='once'
          fullWidth={false}
          size='large'
          backgroundColor={is_header_solid ? vars.color.backgroundSurface : 'transparent'}
          textColors={
            is_header_solid
              ? { default: vars.color.textTertiary, selected: vars.color.textPrimary }
              : { default: vars.color.staticWhite, selected: vars.color.staticWhite }
          }
        />
      </SelectedTextTabWrapper>
      <DefaultComponentList
        type='store'
        params={params}
        {...component_list_props}
        onFetchNextPage={fetchNextPage}
        onParamsChange={onParamsChange}
      />
    </ScrollWrap>
  );
};
